export var UploadStockInvoiceStepIndex;
(function (UploadStockInvoiceStepIndex) {
    UploadStockInvoiceStepIndex[UploadStockInvoiceStepIndex["StockSelect"] = 0] = "StockSelect";
    UploadStockInvoiceStepIndex[UploadStockInvoiceStepIndex["FileUpload"] = 1] = "FileUpload";
    UploadStockInvoiceStepIndex[UploadStockInvoiceStepIndex["CellMapping"] = 2] = "CellMapping";
})(UploadStockInvoiceStepIndex || (UploadStockInvoiceStepIndex = {}));
